export const categories = [
  { id: 'romance', name: '恋爱言情', slug: 'romance', description: '甜宠恋爱、校园纯爱' },
  { id: 'fantasy', name: '奇幻冒险', slug: 'fantasy', description: '异世界、魔法战斗' },
  { id: 'action', name: '热血动作', slug: 'action', description: '格斗竞技、超能战斗' },
  { id: 'drama', name: '剧情悬疑', slug: 'drama', description: '烧脑推理、心理博弈' },
  { id: 'comedy', name: '搞笑日常', slug: 'comedy', description: '轻松搞笑、治愈日常' },
  { id: 'horror', name: '惊悚恐怖', slug: 'horror', description: '悬疑惊悚、灵异怪谈' },
];

export const comics = [
  {
    id: 1,
    slug: 'goddess-descends',
    title: '女神降临',
    author: '猫咪',
    category: 'romance',
    categoryName: '恋爱言情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beautiful%20girl%20portrait%20with%20soft%20romantic%20atmosphere%2C%20warm%20peach%20and%20cream%20background%2C%20anime%20art%20style%2C%20elegant%20fashion%20illustration%2C%20delicate%20facial%20features%2C%20soft%20lighting%2C%20gentle%20expression%2C%20clean%20composition%2C%20light%20pastel%20tones%2C%20romantic%20webtoon%20cover%20style&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    rating: 9.6,
    chapters: 218,
    status: '连载中',
    description: '原本因外貌自卑的平凡女孩，通过化妆技巧摇身一变化身校园女神，在两个截然不同的身份中周旋，遇见真爱的浪漫故事。',
    updatedAt: '2026-07-03',
    tags: ['校园', '恋爱', '逆袭'],
    views: 2850000,
    featured: true,
  },
  {
    id: 2,
    slug: 'solo-leveling',
    title: '我独自升级',
    author: 'CHUGONG / DUBU',
    category: 'action',
    categoryName: '热血动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20fantasy%20warrior%20character%20with%20purple%20energy%20aura%2C%20action%20pose%2C%20dramatic%20lighting%2C%20dark%20gradient%20background%2C%20anime%20art%20style%2C%20epic%20battle%20scene%20vibe%2C%20cool%20shadow%20army%20theme%2C%20clean%20composition%2C%20mysterious%20atmosphere&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    rating: 9.8,
    chapters: 179,
    status: '已完结',
    description: '被称作最弱猎人的成振宇，在一次双重地下城中濒死后觉醒"系统"，成为唯一能够无限升级的猎人，踏上称霸之路。',
    updatedAt: '2026-06-28',
    tags: ['战斗', '升级', '系统流'],
    views: 5200000,
    featured: true,
  },
  {
    id: 3,
    slug: 'true-beauty',
    title: '女神制造',
    author: 'Yaongyi',
    category: 'romance',
    categoryName: '恋爱言情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20comedy%20girl%20with%20makeup%20theme%2C%20cute%20shy%20expression%2C%20soft%20pink%20and%20cream%20background%2C%20anime%20art%20style%2C%20beauty%20transformation%20concept%2C%20delicate%20illustration%2C%20warm%20pastel%20tones%2C%20school%20romance%20vibe%2C%20gentle%20lighting&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    rating: 9.4,
    chapters: 195,
    status: '连载中',
    description: '通过化妆隐藏真实面貌的女孩林周京，在两个完美男人之间陷入三角恋，笑泪交织的校园爱情故事。',
    updatedAt: '2026-07-02',
    tags: ['校园', '化妆', '三角恋'],
    views: 2100000,
    featured: true,
  },
  {
    id: 4,
    slug: 'tower-of-god',
    title: '神之塔',
    author: 'SIU',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20tower%20mysterious%20world%20concept%2C%20boy%20climbing%20toward%20light%2C%20magical%20atmosphere%2C%20anime%20art%20style%2C%20grand%20scale%20adventure%2C%20ethereal%20blue%20and%20gold%20gradient%2C%20epic%20fantasy%20illustration%2C%20mysterious%20silhouettes%2C%20celestial%20background&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    rating: 9.5,
    chapters: 550,
    status: '连载中',
    description: '二十五夜为了追寻唯一的挚友蕾哈尔而进入神秘高塔，在层层考验中揭开塔的真相与隐藏的宏大世界。',
    updatedAt: '2026-07-01',
    tags: ['冒险', '奇幻', '长篇'],
    views: 3800000,
    featured: false,
  },
  {
    id: 5,
    slug: 'sweet-home',
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    category: 'horror',
    categoryName: '惊悚恐怖',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20apartment%20building%20theme%2C%20dark%20eerie%20atmosphere%2C%20monster%20silhouette%2C%20anime%20art%20style%2C%20survival%20horror%20concept%2C%20dim%20lighting%2C%20creepy%20vibe%2C%20dark%20red%20and%20black%20tones%2C%20suspenseful%20composition&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    rating: 9.3,
    chapters: 140,
    status: '已完结',
    description: '因校园暴力而封闭自我的少年车贤秀，在公寓被怪物围困的绝境中，为了守护幸存者而奋战的故事。',
    updatedAt: '2026-06-25',
    tags: ['恐怖', '生存', '怪物'],
    views: 1900000,
    featured: false,
  },
  {
    id: 6,
    slug: 'lookism',
    title: '外貌至上主义',
    author: '朴泰俊',
    category: 'drama',
    categoryName: '剧情悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20two%20contrasting%20characters%2C%20one%20handsome%20one%20plain%2C%20split%20composition%2C%20social%20commentary%20theme%2C%20anime%20art%20style%2C%20urban%20school%20background%2C%20dramatic%20contrast%2C%20clean%20minimal%20cover%20design%2C%20thoughtful%20expression&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    rating: 9.2,
    chapters: 420,
    status: '连载中',
    description: '胖墩墩的男高中生朴亨硕，某天突然拥有了完美帅气的第二个身体，在两个人生间切换，揭示社会对外貌的双重标准。',
    updatedAt: '2026-07-02',
    tags: ['社会', '双面人生', '校园'],
    views: 3100000,
    featured: false,
  },
  {
    id: 7,
    slug: 'wind-breaker',
    title: '疾风传说',
    author: '赵容满',
    category: 'action',
    categoryName: '热血动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20cycling%20action%20theme%2C%20dynamic%20bicycle%20racing%20pose%2C%20wind%20effect%2C%20anime%20art%20style%2C%20energetic%20atmosphere%2C%20youth%20sports%20passion%2C%20speed%20lines%2C%20vibrant%20green%20and%20blue%20tones%2C%20summer%20vibe&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    rating: 9.4,
    chapters: 385,
    status: '连载中',
    description: '天才自行车手赵夏岚加入学校自行车社团，与伙伴们一起在赛道上挥洒热血和青春，追逐速度的极限。',
    updatedAt: '2026-06-30',
    tags: ['竞技', '青春', '自行车'],
    views: 1750000,
    featured: false,
  },
  {
    id: 8,
    slug: 'eleceed',
    title: '超能觉醒',
    author: '孙宰浩 / ZHENA',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20superpower%20teen%20with%20cat%20companion%2C%20electric%20energy%20effect%2C%20dynamic%20pose%2C%20anime%20art%20style%2C%20action%20comedy%20mix%2C%20bright%20vibrant%20colors%2C%20modern%20urban%20setting%2C%20playful%20yet%20cool%20vibe%2C%20superhero%20theme&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    rating: 9.6,
    chapters: 260,
    status: '连载中',
    description: '拥有超能力的少年陈志宇隐瞒身份过着平凡生活，直到遇见神秘的能力者大叔，卷入了超能力者的世界。',
    updatedAt: '2026-07-03',
    tags: ['超能力', '战斗', '猫咪'],
    views: 2400000,
    featured: false,
  },
  {
    id: 9,
    slug: 'secret-class',
    title: '秘密教学',
    author: '姜草',
    category: 'drama',
    categoryName: '剧情悬疑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20psychological%20thriller%2C%20teacher%20and%20student%20theme%2C%20dark%20classroom%20setting%2C%20anime%20art%20style%2C%20suspenseful%20atmosphere%2C%20intricate%20plot%2C%20moody%20lighting%2C%20deep%20shadows%2C%20clean%20composition%2C%20serious%20expression&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    rating: 9.0,
    chapters: 168,
    status: '连载中',
    description: '一位天才心理医生以教师身份潜入校园，暗中实施自己的复仇计划，却一步步发现真相远比想象复杂。',
    updatedAt: '2026-06-29',
    tags: ['悬疑', '复仇', '校园'],
    views: 1650000,
    featured: false,
  },
  {
    id: 10,
    slug: 'romance-101',
    title: '恋爱必修课',
    author: '金彩恩',
    category: 'romance',
    categoryName: '恋爱言情',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20college%20romance%20couple%20theme%2C%20sweet%20dating%20scene%2C%20spring%20cherry%20blossom%20atmosphere%2C%20anime%20art%20style%2C%20warm%20pink%20tones%2C%20youthful%20love%20vibe%2C%20gentle%20smile%2C%20hand%20holding%2C%20romantic%20illustration&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    rating: 9.1,
    chapters: 132,
    status: '连载中',
    description: '大学恋爱小白林多恩，在恋爱经验丰富的室友帮助下，展开了一段又甜又涩的大学恋爱成长记。',
    updatedAt: '2026-07-02',
    tags: ['大学', '甜宠', '成长'],
    views: 1200000,
    featured: false,
  },
  {
    id: 11,
    slug: 'noblesse',
    title: '贵族',
    author: '孙宰浩 / 李光洙',
    category: 'fantasy',
    categoryName: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20vampire%20noble%20elegant%20character%2C%20dark%20gothic%20style%2C%20red%20eyes%2C%20aristocratic%20pose%2C%20anime%20art%20style%2C%20mysterious%20supernatural%20theme%2C%20dark%20red%20and%20black%20gradient%2C%20regal%20atmosphere%2C%20powerful%20aura&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    rating: 9.5,
    chapters: 544,
    status: '已完结',
    description: '沉睡八百年的贵族卡迪斯·艾特拉马·迪·莱杰罗在现代苏醒，以强大的力量守护身边的伙伴。',
    updatedAt: '2026-06-20',
    tags: ['吸血鬼', '战斗', '经典'],
    views: 4500000,
    featured: false,
  },
  {
    id: 12,
    slug: 'yumi-cells',
    title: '柔美的细胞小将',
    author: '李东健',
    category: 'comedy',
    categoryName: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?width=800&height=1100&seq=comic-cover-12&orientation=portrait&query=Korean%20manhwa%20cute%20cartoon%20cells%20characters%2C%20colorful%20playful%20design%2C%20slice%20of%20life%20theme%2C%20anime%20art%20style%2C%20cheerful%20atmosphere%2C%20pastel%20rainbow%20colors%2C%10funny%20expressions%2C%20lighthearted%20vibe%2C%20wholesome%20comedy',
    rating: 9.3,
    chapters: 412,
    status: '已完结',
    description: '用可爱的细胞角色来表现普通上班族柔美的日常生活、恋爱与工作，笑中带泪的生活治愈漫画。',
    updatedAt: '2026-06-15',
    tags: ['治愈', '搞笑', '生活'],
    views: 2000000,
    featured: false,
  },
];

export const popularComics = comics.filter(c => c.rating >= 9.4).sort((a, b) => b.rating - a.rating).slice(0, 6);

export const latestUpdates = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 9);

export const featuredComics = comics.filter(c => c.featured);

export const testimonials = [
  {
    id: 1,
    name: '林小雪',
    role: '韩漫资深读者',
    quote: '这是我用过最舒服的韩漫阅读网站，下拉式阅读体验太流畅了，再也不用一页页翻，看漫画就像看电影一样。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%2C%20natural%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20warm%20lighting%2C%20friendly%20expression%2C%20modern%20fashion&width=200&height=200&seq=testimonial-01&orientation=squarish',
  },
  {
    id: 2,
    name: '张明浩',
    role: '漫画平台运营',
    quote: '更新速度真的快，很多热门作品都是同步更新，画质也超清晰。作为同行，我真心推荐这个平台。',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%2C%20confident%20smile%2C%20modern%20casual%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20warm%20lighting%2C%20friendly%20expression&width=200&height=200&seq=testimonial-02&orientation=squarish',
  },
];